<template>
  <div class="section">
    <div class="section-header">
      <div class="icon">
        <div class="section-title">P幣兌換</div>
      </div>
    </div>
    <div class="section-content">
      <swiper v-bind:options="swiperOption" ref="list-swiper" class="list-swiper">
        <swiper-slide
          class="swiper-slide"
          v-for="(item, index) in point_products"
          :key="'hot' + index">
          <div class="page">
            <loading :active.sync="isLoading" :is-full-page="false"></loading>
            <product-block v-bind="{ info: item, modifier: 'm' }" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import ProductBlock from '../ProductBlock.vue'

export default {
  name: 'ProductSlider',
  components: {
    ProductBlock,
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 2.5,
        initialSlide: 0,
        spaceBetween: 16,
        loop: false,
      },
      point_products:[{
          tp_pic: '../../images/placholder_1200.svg',
        },
        {
          tp_pic: '../../images/placholder_1200.svg',
        },
        {
          tp_pic: '../../images/placholder_1200.svg',
        }],
      isLoading: true,
    }
  },
  methods: {
    getData () {
      axios.get('/ticket/api/product/list')
      .then((response) => {
        this.point_products = response.data.B;
        this.isLoading = false;
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.section ~ .section {
  border-top: 10px solid #f3f5f8;
  margin-top: 30px;
  padding-bottom: 30px;
}
.more-link a {
  text-decoration: none;
  font-size: 0.8rem;
  color: gray;
}
.section-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding: 23px 4.8%;
}

.section-header {
  .icon {
    width: 94px;
    height: 24px;
    img {
      width: 100%;
    }
    .section-title {
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0.56px;
      color: #1da7fc;
    }
  }
}

.touch-area {
  span {
    margin-right: 4px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.5);
  }
}

.list-swiper {
  padding: 0 4.8%;
}
.swiper-container .swiper-slide {
  width: 7.2rem;
}
.swiper-container .swiper-slide img {
  width: 100%;
}
</style>
